import { connect } from 'react-redux'
import { updateEditorState } from '../../actions/editor'
import Editor from './Editor'

const mapStateToProps = state => {
    return {
        editorState: state.editorState.data,
        ignoreWords: state.ignoreList.words,
        isUserLoggedIn: !!state.user.userId,
    }
}

const mapDispatchToProps = dispatch => ({
    saveEditorText: (editorState) => {
        dispatch(updateEditorState(editorState))
    },
})

const EditorContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Editor)

export default EditorContainer
